<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit Shift Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Edit Shift</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
        <a-input v-decorator="['name', { rules: [{ required: false, message: 'Please enter name' }] }]" />
      </a-form-item>

      <a-form-item label="Code">
        <a-input v-decorator="['code', { rules: [{ required: false, message: 'Please enter code' }] }]" />
      </a-form-item>

      <a-form-item label="Description">
        <a-input v-decorator="['description']" />
      </a-form-item>

      <a-row :gutter="16">
        <a-col :span="12">
        <a-form-item label="Start Time">
        <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['start_time', { rules: [{ required: false, message: 'Please select start time' }] }]" />
        </a-form-item>
        </a-col>

        <a-col :span="12">
        <a-form-item label="End Time">
        <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['end_time', { rules: [{ required: false, message: 'Please select end time' }] }]" />
        </a-form-item>
        </a-col>
        </a-row>

        <a-row :gutter="16">
         <a-col :span="12">
         <a-form-item label="Break Start">
         <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['break_start',{rules: [{ required: false, message: 'Please select break start' }]}]" />
         </a-form-item>
         </a-col>
        <a-col :span="12">

        <a-form-item label="Break End">
        <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['break_end',{rules: [{ required: false, message: 'Please select break end' }]}]" />
        </a-form-item>
        </a-col>
        </a-row>

      <a-form-item label="Default">
     <a-select v-decorator="['is_default', { initialValue: 0 }]">
     <a-select-option :value="1">Yes</a-select-option>
     <a-select-option :value="0">No</a-select-option>
     </a-select>
     </a-form-item>

      <a-form-item label="Status">
        <a-select v-decorator="['status', { initialValue: 1 }]">
          <a-select-option :value="1">Active</a-select-option>
          <a-select-option :value="0">Inactive</a-select-option>
        </a-select>
      </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { Row, Col } from 'ant-design-vue'
import { pick, mapValues } from 'lodash'

export default {
  name: 'EditShift',
  components: {
    'a-row': Row,
    'a-col': Col,
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      shiftId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openShiftEditModal', this.showModal)
  },
  methods: {
    toHHmmss(val) {
      if (!val) return null
      return typeof val.format === 'function' ? val.format('HH:mm:ss') : String(val)
    },

    showModal: function(shiftId) {
      this.shiftId = shiftId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/attendance-shift/single/' + shiftId).then(({ data }) => {
        const shiftData = pick({ ...data.data }, ['name', 'code', 'description', 'start_time', 'break_start',
          'break_end', 'end_time', 'is_default', 'status'])
        if (shiftData.start_time) {
          shiftData.start_time = moment(shiftData.start_time, 'HH:mm:ss')
        }
        if (shiftData.end_time) {
          shiftData.end_time = moment(shiftData.end_time, 'HH:mm:ss')
        }
        if (shiftData.break_start) {
          shiftData.break_start = moment(shiftData.break_start, 'HH:mm:ss')
        }
        if (shiftData.break_end) {
          shiftData.break_end = moment(shiftData.break_end, 'HH:mm:ss')
        }
        const fieldsData = mapValues({ ...shiftData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const startTime = this.toHHmmss(values.start_time || null)
          const endTime = this.toHHmmss(values.end_time || null)
          const breakStart = this.toHHmmss(values.break_start || null)
          const breakEnd = this.toHHmmss(values.break_end || null)
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/attendance-shift/single/' + this.shiftId, {
                  name: values.name,
                  code: values.code,
                  description: values.description,
                  start_time: startTime,
                  break_start: breakStart,
                  break_end: breakEnd,
                  end_time: endTime,
                  is_default: values.is_default,
                  status: values.status,

                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Class details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
